import styled from 'styled-components';

type WrapperProps = {
  error: boolean;
};

const Wrapper = styled.div<WrapperProps>`
  height: 74px;
  position: relative;
  background-color: ${(props) => props.theme.colors.widget_background};
  border-radius: 12px;
  border: 1px solid ${(props) => props.theme.colors.outline};
  transition: all .2s ease-in;
  cursor: pointer;
  width: 100%;
  max-width: 100%;
  border: ${(props) => (
    props.error ? `1px solid ${props.theme.colors.red}` : ` 1px solid ${props.theme.colors.widget_background}`
  )};
  margin-bottom: ${(props) => (props.error ? '16px' : 0)};
  
  label {
    position: absolute;
    top: 16px;
    left: 16px;
    color: ${(props) => props.theme.colors.text};
    font-family: ManropeLight, sans-serif;
    font-size: 13px;
    pointer-events: none;
  }

  textarea {
    width: 100%;
    height: 100%;
    padding: 12px;
    font-size: 13px;
    caret-color: ${(props) => props.theme.colors.main_cta};
    color: ${(props) => props.theme.colors.text};
    /* overflow: hidden; */
    resize: none;

    ::placeholder {
      position: absolute;
      color: ${(props) => props.theme.colors.inactive};
      font-size: 13px;
    }

    :disabled {
      cursor: not-allowed;
      opacity: 50%;
    }

    &::-webkit-scrollbar {
      width: 4px;
    }

    &::-webkit-scrollbar-track {
      background: none;
    }

    &::-webkit-scrollbar-thumb {
      background-color: ${(props) => props.theme.colors.inactive};
      border-radius: 20px;
      border: 3px solid ${(props) => props.theme.colors.inactive};
    }
  }

  &:has(textarea:focus) {
    border: 1px solid ${(props) => props.theme.colors.main_cta};
    border-radius: 12px;
  }
  
  &:hover {
    border: ${(props) => (`1px solid ${props.theme.colors.white}`)}
  }
`;

const ErrorMessage = styled.p`
  position: absolute;
  padding-right: 10px;
  bottom: -25px;
  left: 15px;
  font-family: ManropeLight, sans-serif;
  font-size: 13px;
  text-align: right;
  color: ${(props) => props.theme.colors.red};
`;

export default { Wrapper, ErrorMessage };
